import { createContext } from 'react';
import type { PortalContact, DiscoveredTenant, DomainResolutionResult } from '../services/authService';

export interface AuthContextType {
  contact: PortalContact | null;
  discoveredTenant: DiscoveredTenant | null;
  resolvedBranding: DomainResolutionResult | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  discoverTenant: (email: string) => Promise<DiscoveredTenant | null>;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  clearDiscoveredTenant: () => void;
  hasPermission: (permission: string) => boolean;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
